import { useState } from "react";
import "./ProductView.scss";

function ProductView({ images, setOnProductView }) {
    const [mainImage, setMainImage] = useState(0);

    function handleNextImage() {
        setMainImage(mainImage + 1 == images.length ? 0 : mainImage + 1);
    }

    function handlePreviousImage() {
        setMainImage(mainImage == 0 ? images.length - 1 : mainImage - 1);
    }

    function handleCloseProductView() {
        setOnProductView(false);
    }

    return (
        <div className="product-view">
            <div className="platform"></div>

            <div className="content">
                <div className="close-btn">
                    <img
                        src="./images/icon-close.svg"
                        onClick={handleCloseProductView}
                    />
                </div>

                <div className="main-image">
                    <img src={images.at(mainImage)} />
                </div>
                <div className="icon-next" onClick={handleNextImage}>
                    <img src="./images/icon-next.svg" />
                </div>
                <div className="icon-previous" onClick={handlePreviousImage}>
                    <img src="./images/icon-previous.svg" />
                </div>

                <div className="list-images">
                    {images.map((image, index) => (
                        <img src={image} onClick={() => setMainImage(index)} />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ProductView;
